<template>
    
        <v-card :loading="loading" class="pb-80" elevation=0 >
            <v-system-bar
                flat
                color="transparent"
                fixed
                height="40"
                class="pt-3"
            >
                <v-btn href="../team" fab small color="primary">
                    <v-icon class="white--text ">mdi-arrow-left</v-icon>
                </v-btn>

            </v-system-bar>
            <v-card-title class="pa-0">
              
                <v-img  :src="(business.teamimage=='null' || business.teamimage==null )?bannerImg:business.teamimage" aspect-ratio="1" class="lighten-2 " max-height="287">
                    <v-row class="fill-height align-start" style="background:rgba(0,0,0, 0.4);">
                        <v-col cols="12" md="12" sm="12" class=" white--text pl-30">
                            <!-- <div class="mb-10">
                                <router-link to="../team">
                                <v-icon class="white--text" >mdi-arrow-left</v-icon>
                                </router-link>
                            </div> -->
                            <!-- <div class="subtitle-1  grey--text text--lighten-5">{{event.eventcategoryname}}</div>
                            <div class="headline font-weight-bold">{{event.title}}</div>
                            <span class="subtitle-1 font-weight-light">{{event.subtitle}}</span> -->
                                    
                        </v-col>
                    </v-row>
                </v-img>
                        
                    
            </v-card-title>

            <v-card-text class="pl-3 pr-3">
                <v-row>
                    <v-col cols="12" md="12" sm="12" class="text-align-center pb-1" style="margin-top:-48px;padding-top:0px;text-align:center ">
                        <v-avatar size="96px">
                             <img :src="employee.image" :alt="employee.name"/>
                        </v-avatar>
                    </v-col>

                    <v-col cols="12" md="12" sm="12" class="text-align-center pt-0" style="text-align:center;">
                        <div class="title"><span v-if="employee.name!='' && employee.name!='null' && employee.name!=null">{{employee.name+' '}}</span> <span v-if="employee.lastname!='' && employee.lastname!='null' && employee.lastname!=null">{{employee.lastname}}</span></div>
                        <div class="subtitle-1" v-if="employee.designation!='' && employee.designation!='null' && employee.designation!=null">{{employee.designation}}</div>
                    </v-col>
                </v-row>

                <v-row v-if="employee.description!='' && employee.description!=null">
                    <v-col cols="12" md="12" sm="12" class="" >
                        <div class="title font-weight-bold">Description</div>
                        <div v-html="employee.description"></div>
                    </v-col>
                </v-row>

               
                <v-card v-if="employee.nationality!='' && employee.nationality!=null && employee.nationality!='null'">
                    <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-15" >
                        <v-row>
                            <v-col cols="4" md="4" sm="4" class="pt-2 pb-2">
                                <div class="subtitle-1 font-weight-bold">I am from</div>
                            </v-col>
                            <v-col cols="8" md="8" sm="8" class="pt-2 pb-2">
                                <div class="">{{employee.nationality}}</div>
                            </v-col>    
                                
                        </v-row>
                                
                    </v-card-text>
                </v-card>

                <v-card v-if="employee.languages!='' && employee.languages!=null  && employee.languages!='null'">
                    <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-15" >
                        <v-row>
                            <v-col cols="4" md="4" sm="4" class="pt-2 pb-2">
                                <div class="subtitle-1 font-weight-bold">I Speak</div>
                            </v-col>
                            <v-col cols="8" md="8" sm="8" class="pt-2 pb-2">
                                <div class="">{{employee.languages}}</div>
                            </v-col>    
                                
                        </v-row>
                                
                    </v-card-text>
                </v-card>

                <v-card v-if="employee.hobbies!='' && employee.hobbies!=null && employee.hobbies!='null'">
                    <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-15" >
                        <v-row>
                            <v-col cols="4" md="4" sm="4" class="pt-2 pb-2">
                                <div class="subtitle-1 font-weight-bold">My Hobbies</div>
                            </v-col>
                            <v-col cols="8" md="8" sm="8" class="pt-2 pb-2">
                                <div class="">{{employee.hobbies}}</div>
                            </v-col>    
                                
                        </v-row>
                                
                    </v-card-text>
                </v-card>

                <v-card v-if="employee.hero!='' && employee.hero!=null && employee.hero!='null'">
                    <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-15" >
                        <v-row>
                            <v-col cols="4" md="4" sm="4" class="pt-2 pb-2">
                                <div class="subtitle-1 font-weight-bold">My Hero</div>
                            </v-col>
                            <v-col cols="8" md="8" sm="8" class="pt-2 pb-2">
                                <div class="">{{employee.hero}}</div>
                            </v-col>    
                                
                        </v-row>
                                
                    </v-card-text>
                </v-card>

                <v-row v-if="employee.dataofjoining!='' && employee.dataofjoining!='null' && employee.dataofjoining!=null">
                    <v-col cols="12" md="12" sm="12" class="text-right">
                        Joined From {{employee.dataofjoining}}
                    </v-col>
                </v-row>
                   
            </v-card-text>
        </v-card>

        

        
       
</template>
<script>
import Vue from 'vue'
export default {
    props:['business','employee'],
    data: () => 
    ({
        bannerImg:require('@/assets/overview-banner.jpg'),
       // bannerImg:'',
        logoImg:require('@/assets/logo.svg'),
        loading:false,
        isUsed: false,
        search: null,
        valid: true,
        isAgent: false,
        isSameUser:false,
        business_id: 0,
        businesses: [],
        storeBusiness: [],
        tagBusiness: {},
        code:0,
        starrating:0,
        activeBtn: 3,
        data:[],
        team_id:0,
        dimage:'',
        
    }),
    
    watch:{
            employee:function(value)
            {
                return value;
            }
        },
    methods:
    {
       
        teamdetail()
        {
            this.$http
            
            .get( this.$apidomain+"employeeData/" + this.team_id)
            .then(res => {
            this.employee =res.data.Employee;
            this.business_id=this.employee.businesses_id;
            this.getBusiness();
            // this.bannerImg=this.businesses.teamimage;
            // if(this.bannerImg==null || this.bannerImg=='null')
            // {
            //     this.bannerImg=require('@/assets/overview-banner.jpg');
            // }  
            
            //console.log(this.businesses);
            })
            .catch(err => {
            console.log(err.response);
            });
        },
       

    }
}
</script>
<style>
.mb-15{
    margin-bottom: 15px;
}
.pt-81{
    padding-top: 3rem !important;
}
</style>